import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class FundraiserQualifier {
    phase = CouponApplyPhase.PreApply;
    _data;
    constructor(sourceData) {
        this._data = sourceData;
    }
    qualify(_, cart) {
        const fundraiser = this._data.fundraisers?.find(f => f.fundraiserId === cart.fundraiserId);
        if (fundraiser && !fundraiser.isCouponAllowed) {
            return { isValid: false, errorCode: CouponApplyErrorCode.FUNDRAISER_DOES_NOT_ALLOW_COUPON };
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=fundraiser.js.map